module.exports = __webpack_public_path__ + "static/img/grade-chengji.e61ff0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade-chengji.png
// module id = H1yV
// module chunks = 0